
import React, { useEffect, useState } from "react";

function HackerLoader({ finish }) {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (typeof finish === "function") {
      const exitTimer = setTimeout(() => {
        setIsExiting(true);
      }, 3000);

      const finishTimer = setTimeout(() => {
        finish();
      }, 3600);

      return () => {
        clearTimeout(exitTimer);
        clearTimeout(finishTimer);
      };
    }
  }, [finish]);

  return (
    <div className={`welcome-loader ${isExiting ? "loader-exit" : ""}`}>
      <style>{`
        .welcome-loader {
          position: fixed;
          inset: 0;
          z-index: 99999;
          overflow: hidden;

          display: flex;
          align-items: center;
          justify-content: center;

          background:
            radial-gradient(
              circle at 50% 45%,
              rgba(37, 99, 235, 0.10),
              transparent 38%
            ),
            #050505;

          color: #fff;

          font-family:
            Inter,
            Poppins,
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            sans-serif;

          transition:
            opacity 0.7s ease,
            transform 0.7s cubic-bezier(.16,1,.3,1),
            filter 0.7s ease;
        }

        .welcome-loader.loader-exit {
          opacity: 0;
          transform: scale(1.03);
          filter: blur(12px);
          pointer-events: none;
        }

        /* --------------------------------
           BACKGROUND
        -------------------------------- */

        .welcome-grid {
          position: absolute;
          inset: 0;

          background-image:
            linear-gradient(
              rgba(255,255,255,.025) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(255,255,255,.025) 1px,
              transparent 1px
            );

          background-size: 70px 70px;

          mask-image:
            radial-gradient(
              ellipse at center,
              black 10%,
              transparent 75%
            );

          -webkit-mask-image:
            radial-gradient(
              ellipse at center,
              black 10%,
              transparent 75%
            );

          animation: gridMove 8s linear infinite;
        }

        @keyframes gridMove {
          from {
            transform: translateY(0);
          }

          to {
            transform: translateY(70px);
          }
        }

        .welcome-glow {
          position: absolute;

          width: 500px;
          height: 500px;

          border-radius: 50%;

          background:
            radial-gradient(
              circle,
              rgba(37,99,235,.16),
              transparent 68%
            );

          filter: blur(40px);

          animation: glow 3s ease-in-out infinite alternate;
        }

        @keyframes glow {
          from {
            transform: scale(.8);
            opacity: .45;
          }

          to {
            transform: scale(1.15);
            opacity: .9;
          }
        }

        /* --------------------------------
           CONTENT
        -------------------------------- */

        .welcome-content {
          position: relative;
          z-index: 5;

          width: min(90%, 1000px);

          display: flex;
          flex-direction: column;
          align-items: center;

          text-align: center;
        }

        /* Small top text */

        .welcome-small {
          overflow: hidden;

          margin-bottom: 18px;

          font-size: 12px;
          font-weight: 500;

          letter-spacing: .35em;

          text-transform: uppercase;

          color: rgba(255,255,255,.45);

          animation: smallReveal .8s ease forwards;
        }

        @keyframes smallReveal {
          from {
            opacity: 0;
            transform: translateY(20px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* WELCOME */

        .welcome-title {
         margin: 0;

  font-size: clamp(2.2rem, 6vw, 4.8rem);

  font-weight: 700;
  line-height: 0.95;
  letter-spacing: -0.04em;

  color: #fff;
  overflow: hidden;
        }

        .welcome-word {
          display: block;

          animation:
            titleReveal
            1s
            cubic-bezier(.16,1,.3,1)
            forwards;

          transform: translateY(110%);
          opacity: 0;
        }

        .welcome-word:nth-child(1) {
          animation-delay: .25s;
        }

        .welcome-word:nth-child(2) {
          animation-delay: .4s;

          color: transparent;

          -webkit-text-stroke:
            1px rgba(255,255,255,.7);
        }

        @keyframes titleReveal {
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        /* --------------------------------
           DIVIDER
        -------------------------------- */

        .welcome-divider {
          display: flex;
          align-items: center;

          width: min(500px, 70%);

          margin: 32px 0;
        }

        .welcome-divider-line {
          height: 1px;
          flex: 1;

          background:
            linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,.35)
            );

          transform-origin: right;

          animation:
            lineReveal
            1s
            ease
            .8s
            forwards;

          transform: scaleX(0);
        }

        .welcome-divider-line.right {
          background:
            linear-gradient(
              90deg,
              rgba(255,255,255,.35),
              transparent
            );

          transform-origin: left;
        }

        .welcome-dot {
          width: 6px;
          height: 6px;

          margin: 0 14px;

          border-radius: 50%;

          background: #3b82f6;

          box-shadow:
            0 0 12px #3b82f6,
            0 0 30px rgba(59,130,246,.5);

          animation:
            dotPulse
            1.5s
            ease-in-out
            infinite;
        }

        @keyframes lineReveal {
          to {
            transform: scaleX(1);
          }
        }

        @keyframes dotPulse {
          0%,100% {
            transform: scale(.7);
            opacity: .5;
          }

          50% {
            transform: scale(1.2);
            opacity: 1;
          }
        }

        /* --------------------------------
           NAME
        -------------------------------- */

        .welcome-name {
          margin: 0;

          font-size:
            clamp(1.2rem, 3vw, 2rem);

          font-weight: 500;

          letter-spacing: .12em;

          text-transform: uppercase;

          color: rgba(255,255,255,.85);

          animation:
            nameReveal
            1s
            cubic-bezier(.16,1,.3,1)
            1s
            forwards;

          opacity: 0;
          transform: translateY(20px);
        }

        .welcome-name span {
          color: #3b82f6;

          text-shadow:
            0 0 20px rgba(59,130,246,.4);
        }

        @keyframes nameReveal {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* --------------------------------
           BOTTOM
        -------------------------------- */

        .welcome-bottom {
          position: absolute;

          bottom: 35px;

          left: 50%;

          transform: translateX(-50%);

          display: flex;
          align-items: center;
          gap: 10px;

          font-size: 10px;

          letter-spacing: .2em;

          text-transform: uppercase;

          color: rgba(255,255,255,.3);

          animation:
            bottomReveal
            1s
            ease
            1.2s
            forwards;

          opacity: 0;
        }

        .loading-bar {
          width: 50px;
          height: 1px;

          overflow: hidden;

          background: rgba(255,255,255,.1);
        }

        .loading-progress {
          width: 100%;
          height: 100%;

          background: #3b82f6;

          transform-origin: left;

          animation:
            loading
            2.8s
            cubic-bezier(.4,0,.2,1)
            forwards;
        }

        @keyframes loading {
          from {
            transform: scaleX(0);
          }

          to {
            transform: scaleX(1);
          }
        }

        @keyframes bottomReveal {
          to {
            opacity: 1;
          }
        }

        /* --------------------------------
           MOBILE
        -------------------------------- */

        @media (max-width: 600px) {
  .welcome-title {
    font-size: 14vw;
  }

  .welcome-divider {
    margin: 25px 0;
  }

  .welcome-name {
    font-size: 1rem;
  }

  .welcome-bottom {
    bottom: 25px;
  }
}

        /* Reduced motion */

        @media (prefers-reduced-motion: reduce) {
          *,
          *::before,
          *::after {
            animation-duration: .01ms !important;
            animation-iteration-count: 1 !important;
          }
        }
      `}</style>

      {/* Background */}
      <div className="welcome-grid" />
      <div className="welcome-glow" />

      {/* Main */}
      <div className="welcome-content">

        <div className="welcome-small">
          Portfolio • 2026
        </div>

        <h1 className="welcome-title">
          <span className="welcome-word">
            WELCOME
          </span>

          <span className="welcome-word">
            VISITOR
          </span>
        </h1>

        <div className="welcome-divider">
          <div className="welcome-divider-line" />

          <div className="welcome-dot" />

          <div className="welcome-divider-line right" />
        </div>

        <h2 className="welcome-name">
          I'm <span>Ravi Singh</span>
        </h2>

      </div>

      {/* Bottom loading */}
      <div className="welcome-bottom">
        <span></span>

        <div className="loading-bar">
          <div className="loading-progress" />
        </div>
      </div>
    </div>
  );
}

export default HackerLoader;
